<template>
    <div class="mb-4">
        <Chart :options="chartOptions" />
    </div>
</template>
<script setup>
import {defineProps, computed} from "vue";
import { Chart } from 'highcharts-vue'
import Highcharts from 'highcharts';
import accessibilityInit from 'highcharts/modules/accessibility'; // Import the accessibility module
import exportingInit from 'highcharts/modules/exporting';

// Initialize the accessibility module
accessibilityInit(Highcharts);
// Initialize the exporting module
exportingInit(Highcharts);


const props = defineProps(['data'])
const chartData = computed(()=>{
  return props.data;
})
const chartOptions = {
    chart: {
      type: 'column',
    },
    title: {
      text: 'OpEx',
    },
    xAxis: {
      categories: props.data.map(item=>item.name),
      crosshair: true,
      title:{
        text:"run (scenario)"
      }
    },
    yAxis: {
      title: {
        text: '€',
      },
    },
    series: [{
      name:"OpEx",
      data:props.data
    }],
    exporting: {
      enabled: true,
    },
    plotOptions:{
        column:{
            color:'orange',
        }
    },
    legend:{
      enabled:false
    },
  };
</script>